import React from 'react';
import InnerSmsList from '../../sms/InnerSmsList';

class SmsTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
    <div className={`tab-pane fade ${tab === 'sms' ? 'show active in' : ''}`}>
        <div className="row">
            <div className="col-md-12">
                <InnerSmsList id={this.props.id} type={this.props.type} {...this.props} 
                    reload={this.props.reload} />
            </div>
        </div>
    </div>
    );
  }
}
export default SmsTab;